import { styled } from 'styled-components';

export const StyledApp = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const StyledAppContent = styled.div`
  flex: 1 0 auto;
`;
